import {CommentsCategory} from '@domain/comments'
import {useNotification} from '@hconnect/uikit/src/common'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {mutations} from '../../../api/mutations'
import {notifyIfErrorMessage} from '../../../common'
import {PlannerQueryClient} from '../../../components/providers/QueryProvider'
import {useTrackPlannerEvent} from '../../../helpers/trackPlannerEvents'
import {ErrorResponse} from '../../../interfaces/api'

export const useUpdateAssetComment = () => {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()
  const {t} = useTranslation()
  const trackPlannerEvent = useTrackPlannerEvent()
  const {mutateAsync} = useMutation<
    void,
    AxiosError<ErrorResponse>,
    Parameters<typeof mutations.editComment>[0]
  >({
    mutationFn: mutations.editComment,
    onError: (error) => {
      notifyIfErrorMessage(error.response?.data.detail, raiseError, notify)
    },
    onSuccess: () => {
      notify('success', t('success.editedAssetComment'))
      trackPlannerEvent({name: 'onCommentEditToAsset'})
    },
    onSettled: () => {
      void PlannerQueryClient.invalidateQueries({
        queryKey: ['comments', {commentsCategory: CommentsCategory.Assets}]
      })
    }
  })

  return (params: Omit<Parameters<typeof mutations.editComment>[0], 'commentsCategory'>) =>
    mutateAsync({...params, commentsCategory: CommentsCategory.Assets})
}
